// Categorías de gasto — fuente única para el alta y la edición.
//
// La lista vivía duplicada en NewExpense.vue y UpdateExpense.vue, y en la app
// móvil por tercera vez con un contenido distinto: bastaba tocar una para que
// los formularios ofrecieran cosas diferentes.
//
// `Planilla` es el ÚNICO valor con significado para los cálculos: el balance por
// propiedad lo excluye de los gastos operativos (aquí en `EstateDetail.vue`, y
// igual en la app y en el MCP de métricas) porque la planilla real sale de
// `payrollPeriods` y contarla dos veces inflaría el gasto. El resto de las
// categorías sólo agrupa, así que agregar una no afecta a ningún cálculo.
//
// `Misceláneos` va al final a propósito: es el cajón de sastre, y hasta ahora se
// llevaba el 62% de los gastos por falta de dónde más ponerlos.
export const EXPENSE_TYPES = [
  'Agua',
  'Luz',
  'Internet',
  'Mantenimiento',
  'Limpieza e insumos',
  'Marketing y eventos',
  'Obra',
  'Planilla',
  'Misceláneos'
]
